import { render, staticRenderFns } from "./AddAgents.vue?vue&type=template&id=4e2e8499&"
import script from "./AddAgents.vue?vue&type=script&lang=js&"
export * from "./AddAgents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e2e8499')) {
      api.createRecord('4e2e8499', component.options)
    } else {
      api.reload('4e2e8499', component.options)
    }
    module.hot.accept("./AddAgents.vue?vue&type=template&id=4e2e8499&", function () {
      api.rerender('4e2e8499', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/AddAgents.vue"
export default component.exports